// removed by extract-text-webpack-plugin
module.exports = {"button":"RegisterForm__button___2Tz7N"};


//////////////////
// WEBPACK FOOTER
// ./core/src/components/register/RegisterForm.css
// module id = 1184
// module chunks = 0